import React from 'react'
import { useState, useEffect } from 'react';

// mui material
import {
    Box, Button,
} from '@mui/material';
import Grid from '@mui/system/Unstable_Grid/Grid';
import AddIcon from '@mui/icons-material/Add';

// project import
import { gridSpacing } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import SportsTypeList from './SportsTypeList';
import useApi from 'hooks/useApi';
import AppSettings from 'services/MasterService';
import { CreateSportsTyper } from './CreateSportsType';

export const SportsType = () => {

    const [open, setOpen] = useState(false);
    const [selectedSportsType, setSelectedSportsType] = useState('')
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);

    const handleStCloseDialog = () => {
        setOpen(false);
        setSelectedSportsType(null);
    };

    const handleStOpenDialog = (selectedStUuid) => {
        if (selectedStUuid) {
            getStByUuid.execute(selectedStUuid);
            setOpen(true);
        } else {
            setOpen(true);
        }
    };

    const getStHandler = (response) => {
        setSelectedSportsType(response.data);
    };

    const getStListHandler = (response) => {
        const data = response.data;
        setRows(data);
    };

    const sportsTypeListApi = useApi(AppSettings.getSpotsTypeList, getStListHandler);
    const getStByUuid = useApi(AppSettings.getSportsTypeByUuid, getStHandler)

    useEffect(() => {
        sportsTypeListApi.execute();
    }, [reload]);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard title={
                <Grid container sx={{ alignItems: 'center', justifyContent: "space-between" }} spacing={gridSpacing}>
                    <Grid item xs={12} md={3}>
                    </Grid>
                    <Grid xs={12} md={3}>
                        <Grid container justifyContent={{ xs: 'flex-start', md: 'flex-end' }} alignItems='center' spacing={gridSpacing}>
                            <Grid item>
                                <Button startIcon={<AddIcon />} variant='contained' color='secondary' onClick={() => handleStOpenDialog()}>Create Sports Type</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
                content={false}
            >
                <SportsTypeList
                    rows={rows}
                    setReload={setReload}
                    open={open}
                    handleOpen={handleStOpenDialog}

                />
            </MainCard>
            <CreateSportsTyper
                open={open}
                handleClose={handleStCloseDialog}
                selectedSportsType={selectedSportsType}
                setReload={setReload}
            />
        </Box>
    )
};
